import styled from 'styled-components';
import { Logotype } from '../v2/foundation/Logotype/index.js';
import { pxToRem, padding, marginLeft, marginRight, unit } from '../v2/foundation/spacing/utils.js';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import { breakpoint } from '../deprecated/theme/breakpoints/values.js';
import { fontSize } from '../theme/typography/fontSize.js';
import { fontWeight } from '../theme/typography/fontWeight.js';
import { interactiveTransition } from '../v2/foundation/theme/utils.js';

var HEIGHT = 64;
var TopBarContainer = styled.div.withConfig({
  displayName: "TopBarContainer",
  componentId: "sc-168wqe9-0"
})(["flex:0 0 auto;width:100%;position:sticky;top:0;height:", ";border-bottom:", " solid ", ";box-sizing:content-box;"], pxToRem(HEIGHT), pxToRem(1), themeGet('colors.gray.100'));
var TopBarHeader = styled.header.withConfig({
  displayName: "TopBarHeader",
  componentId: "sc-168wqe9-1"
})(["", ";display:flex;box-sizing:border-box;align-items:center;justify-content:space-between;height:", ";max-width:", ";margin-left:auto;margin-right:auto;background-color:", ";@media ", "{", ";}"], padding(0, 4), pxToRem(HEIGHT), pxToRem(1440), themeGet('colors.gray.0'), breakpoint.lapAndUp, padding(0, 6));
var Left = styled.div.withConfig({
  displayName: "Left",
  componentId: "sc-168wqe9-2"
})(["display:inline-flex;align-items:center;margin-right:auto;"]);
var Center = styled.div.withConfig({
  displayName: "Center",
  componentId: "sc-168wqe9-3"
})(["flex:1 auto;align-items:center;", ";", ";max-width:", ";@media ", "{", ";", ";}"], marginLeft(2), marginRight(2), unit(160), breakpoint.lapAndUp, marginLeft(6), marginRight(6));
var Right = styled.div.withConfig({
  displayName: "Right",
  componentId: "sc-168wqe9-4"
})(["display:flex;align-items:center;justify-content:flex-end;margin-left:auto;"]);
var Navigation = styled.nav.withConfig({
  displayName: "Navigation",
  componentId: "sc-168wqe9-5"
})(["display:flex;justify-content:center;align-items:center;height:100%;"]);
var LogoLink = styled.a.withConfig({
  displayName: "LogoLink",
  componentId: "sc-168wqe9-6"
})(["text-decoration:none;"]);
var StyledLogo = styled(Logotype).withConfig({
  displayName: "StyledLogo",
  componentId: "sc-168wqe9-7"
})(["width:", ";vertical-align:middle;"], pxToRem(87));
var DropdownContainer = styled.button.withConfig({
  displayName: "DropdownContainer",
  componentId: "sc-168wqe9-8"
})(["", ";", ";", ";display:flex;align-items:stretch;height:100%;background-color:transparent;border:0;box-shadow:", ";color:", ";text-decoration:none;", ";&:hover{color:", ";}&:focus-visible{outline:0;box-shadow:inset 0 0 0 ", " ", ";}"], padding(0, 4), fontSize('small'), fontWeight('semibold'), function (props) {
  return props['aria-expanded'] === 'true' ? "inset 0 0 0 " + pxToRem(4) + " " + themeGet('colors.primary.50') : undefined;
}, function (props) {
  return props['aria-expanded'] === 'true' ? themeGet('colors.primary.900') : themeGet('colors.gray.400');
}, interactiveTransition, themeGet('colors.primary.900'), pxToRem(4), themeGet('colors.primary.50'));
var Column = styled.div.withConfig({
  displayName: "Column",
  componentId: "sc-168wqe9-9"
})(["display:flex;align-items:center;&:not(:last-child){", ";}> *:not(:last-child){", ";}"], marginRight(2), marginRight(2));

export { Center, Column, DropdownContainer, HEIGHT, Left, LogoLink, Navigation, Right, StyledLogo, TopBarContainer, TopBarHeader };
